import { render, staticRenderFns } from "./IconPageLast.vue?vue&type=template&id=5b421b76&"
import script from "./IconPageLast.vue?vue&type=script&lang=js&"
export * from "./IconPageLast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports